<script setup lang="js">
import { useAutoformStore } from '@/stores/autoform.store';
import { storeToRefs } from 'pinia';
import useModal from '@/stores/modal.store';
import DeleteModal from '@/components/modals/DeleteModal.vue';
import AutoCatalogModal from '../modals/AutoCatalogModal.vue';

const autoformStore = useAutoformStore();
const { custom_variables, selectedAutoCatalogIndex, outputVariableList, autoCatalogs } =
  storeToRefs(autoformStore);
const { activeModal, closeModal } = useModal();

function getFieldName(entity, entity_id) {
  return (
    outputVariableList.value?.find((v) => v.name === `${entity}.${entity_id}`)?.title ||
    'Отсутствует переменная'
  );
}

function getVariableTitle(variableName) {
  let variable = custom_variables.value?.find((v) => v.name == variableName);
  return variable?.title || 'Отсутствует переменная';
}

function openUpdateModal(index) {
  selectedAutoCatalogIndex.value = index;
  activeModal.value = 'AutoCatalogModal';
}

function openDeleteModal(index) {
  selectedAutoCatalogIndex.value = index;
  activeModal.value = 'deleteModal';
}

function deleteAutoCatalog() {
  autoCatalogs.value.splice(selectedAutoCatalogIndex.value, 1);
  closeModal();
}
</script>

<template>
  <div class="autoform-variables">
    <div class="d-flex justify-content-between align-items-center input-btns">
      <div class="add-btn" @click="activeModal = 'AutoCatalogModal'">
        <img src="@/assets/img/plus-ico.svg" alt="plus-ico.svg" />
        Добавить автосправочник
      </div>
    </div>
    <div class="table-responsive">
      <table class="table gray-table">
        <thead>
          <tr>
            <th>Переменная</th>
            <th>Справочник (в исполняемой системе)</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(autoCatalog, index) in autoCatalogs" :key="index">
            <td>
              {{ getVariableTitle(autoCatalog.variable) }}
            </td>
            <td>
              {{ getFieldName('input_catalog', autoCatalog.input_catalog_id) }}
            </td>
            <td>
              <div class="table-buttons">
                <div class="table-button" @click="openUpdateModal(index)">
                  <span class="edit-ico" />
                </div>
                <div class="table-button" @click="openDeleteModal(index)">
                  <span class="delite-ico" />
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <DeleteModal
    v-if="activeModal === 'deleteModal'"
    :itemText="'эту строку'"
    @confirmDelete="deleteAutoCatalog()"
  />

  <AutoCatalogModal v-if="activeModal === 'AutoCatalogModal'" />
</template>